module.exports = __webpack_public_path__ + "static/img/free1.aea8481.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/free1.png
// module id = o1vE
// module chunks = 1